import React from 'react';

import PropTypes from 'prop-types';

import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Breadcrumbs } from '../../../../shared/components/Breadcrumbs';
import { SearchBar } from '../../../../shared/components/SearchBar';
import { TABS_CONFIG } from '../../constants';
import ViewToggle from './ViewToggle';

const Header = ({ activeTab, onNewClick, onSearchChange, searchInput }) => {
  const { filterButton: FilterButton, newButton: NewButton } = TABS_CONFIG.find(
    (tab) => tab.value === activeTab
  );

  return (
    <div className="flex items-center justify-between p-2 border-b">
      <div className="flex items-center gap-2">
        <SidebarTrigger className="-mr-1.5" />
        <Separator className="data-[orientation=vertical]:h-4" orientation="vertical" />
        <Breadcrumbs />
      </div>

      <div className="flex items-center gap-2">
        <ViewToggle />
        <NewButton onClick={onNewClick} />
        <FilterButton />
        <SearchBar className="h-[30px]" onChange={onSearchChange} value={searchInput} />
      </div>
    </div>
  );
};

Header.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onNewClick: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
};

export default Header;
